import { Text } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';

import { calculateRiskLevel } from '~/common/config/pcfra/risk';
import { severitySchema } from '~/common/schemas/pcfra';
import { Severity } from '~/common/types/pcfra';

import {
  RiskMatrixRoot,
  MatrixInner,
  GridCell,
  KeyX,
  HeadingX,
  MatrixLeft,
  KeyY,
  HeadingY,
  MatrixContainer,
} from './RiskMatrix.styled';

type Props = {
  fireLikelihood?: Severity;
  harmPotential?: Severity;
};

const severityOptions = severitySchema.options;

export const RiskMatrix: FunctionComponent<Props> = ({ fireLikelihood, harmPotential }) => {
  const disabled = !fireLikelihood || !harmPotential;
  const currentRiskLevel = disabled ? '' : calculateRiskLevel(fireLikelihood, harmPotential);

  return (
    <RiskMatrixRoot $disabled={disabled}>
      <MatrixContainer>
        <MatrixLeft>
          <KeyY>
            <div>Likelihood</div>
          </KeyY>
          {severityOptions.map((value) => (
            <HeadingY key={value}>{value}</HeadingY>
          ))}
        </MatrixLeft>
        <MatrixInner>
          <KeyX>Potential consequences</KeyX>
          {severityOptions.map((value) => (
            <HeadingX key={value}>{value}</HeadingX>
          ))}
          {severityOptions.map((severityY) =>
            severityOptions.map((severityX) => (
              <GridCell
                key={`${severityX},${severityY}`}
                $selected={fireLikelihood === severityY && harmPotential === severityX}
              >
                {calculateRiskLevel(severityX, severityY)}
              </GridCell>
            )),
          )}
        </MatrixInner>
      </MatrixContainer>
      <Text
        $weight={600}
      >{`Considering the above, the overall risk level is: ${currentRiskLevel}`}</Text>
    </RiskMatrixRoot>
  );
};
